import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import ConnectedFlagsProvider from '../redux/flags/ConnectedFlagsProvider';
import 'focus-visible';
var DaAppWrapper = function (_a) {
    var store = _a.store, children = _a.children, headTags = _a.headTags;
    var content = children;
    if (process.env.NODE_ENV !== 'production') {
        content = (React.createElement(Flag, { condition: "strictmode", render: function () { return React.createElement(React.StrictMode, null, children); }, fallbackRender: function () { return React.createElement(React.Fragment, null, children); } }));
    }
    return (React.createElement(HelmetProvider, { context: headTags },
        React.createElement(Provider, { store: store },
            React.createElement(ConnectedFlagsProvider, null, content))));
};
DaAppWrapper.displayName = 'DaAppWrapper';
export default DaAppWrapper;
//# sourceMappingURL=DaAppWrapper.js.map